import clientSaleFullcont from "./clientSale-fullcont.html";

const dialog = require('../../../../../components/dialog/dialog')
const fullcontEntity = require('../../../../../components/fullcont/fullcont-entity')
const fullcontHandler = require('../../../../../components/fullcont/fullcont-handler')
const clientSaleDt = require('./clientSale-dt')
const handler = require('./clientSale-fullcont-handler')
const { formCopy } = require('./clientSale-fullcont-form')
const { form } = require('./clientSale-fullcont-form')
const { clientSaleMT } = require('./clientSale-fullcont-multitable')
const restriction = require('./clientSale-fullcont-restriction')
const notification = require('./clientSale-fullcont-notification')

/****************ELEMENTS*****************/
var htmlFc = {}
var HTMLwasSelected = false
var input_send_email = false

function HTMLselect(detail) {

      fullcontHandler.HTMLselect(

            'clientSale', //database table name****
            'clientSale', //dest entity on js
            'clientSale-fullcont',
            clientSaleFullcont, form, formCopy, clientSaleMT,
            editDialog, deleteDialog, dtCall, htmlFc)

      HTMLwasSelected = true

      // htmlFc.hasFiles = true
      // fullcontHandler.rightsControl(htmlFc) 
}/**/


export function start(detail) {
      //console.log('clientSale-dt 5>', detail)

      if (!HTMLwasSelected) { HTMLselect(detail) }

      obj[detail.act].start(detail)
}/**/


const obj = {
      prepareEdit: { start: (detail) => { fullcontHandler.prepareEdit(detail, htmlFc) } },
      prepareView: { start: (detail) => { fullcontHandler.prepareView(detail, htmlFc) } },
      hide: { start: (detail) => { fullcontEntity.hide(detail, htmlFc) } },
      selectOne: { start: (detail) => { selectOne(detail, htmlFc) } },
      otherFieldCustomer: { start: (detail) => { handler.otherFieldCustomer(detail, htmlFc) } },
      otherFieldItem: { start: (detail) => { handler.otherFieldItem(detail, htmlFc) } },
      shippingnow: { start: (detail) => { handler.shippingnow(htmlFc) } },
      insertshippingdatetime: { start: (detail) => { handler.insertshippingdatetime(htmlFc) } },
      showcost: { start: (detail) => { handler.showcost(htmlFc) } },
      showreturn: { start: (detail) => { handler.showreturn(htmlFc) } },
      calculatepaymentdue: { start: (detail) => { handler.calculatepaymentdue(htmlFc) } },
}/**/

function selectOne(detail, htmlFc) {
      const entityFc = document.querySelector('#clientPurchase-fullcont');

      if (entityFc) {
            if (entityFc.classList.contains('fullcont-show')) {
                  entityFc.classList.remove('fullcont-show');
                  fullcontEntity.selectOne(detail, htmlFc, process_required_field_select_one)
                  return;
            }
      }

      fullcontEntity.selectOne(detail, htmlFc, process_required_field_select_one)
}

//function to send
function editDialog() {
      dialog.start({ act: "show", id: "saveChanges", entity: 'clientSale' })
}

function deleteDialog(detail) {
      dialog.start({ act: "show", dest: 'clientSale', id: "deleteElem", entity: 'clientSale', dbid: detail.dbid })
}

function dtCall(act, result) {
      clientSaleDt.start({ act: act, row: result })
}

function process_required_field_select_one(data, result) {

      handler.fill_InventoryStock(data)

      let clientSale_showcost = htmlFc.fullcontHTML.querySelector('#showcost');
      clientSale_showcost.checked = false;
      let event = new Event('change');
      clientSale_showcost.dispatchEvent(event);

      let return_mt = htmlFc.fullcontHTML.querySelector('#return');
      return_mt.classList.remove('dn');

      let clientSale_showreturn = htmlFc.fullcontHTML.querySelector('#showreturn');
      clientSale_showreturn.checked = false;

      event = new Event('change');
      clientSale_showreturn.dispatchEvent(event);

}